"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStudentFullDiagnosis = exports.getStudentDiagnosis = exports.getStudentBasicDiagnostic = exports.getNextHierarchyId = exports.updateHistoryAndGetNextHierarchyIds = exports.loadHistoryAndGetNextHierarchyIds = exports.loadAllModulesHistory = exports.initBanditManchot = void 0;
var data_utils_1 = require("./data-utils");
/**
 * Instanciate classes for each module. If one instanciation fails, the module
 * is not added to the object.
 */
var initBanditManchot = function (config, data, errorHandler) { return __awaiter(void 0, void 0, void 0, function () {
    var AI, banditManchot;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, Promise.resolve().then(function () { return __importStar(require("./" + config.id)); })];
            case 1:
                AI = (_a.sent()).default;
                banditManchot = {};
                data.modules.forEach(function (module) {
                    try {
                        banditManchot[module.id] = {
                            historyLoaded: false,
                            instance: new AI(__assign(__assign({}, config.baseConfig), { graph: __assign(__assign({}, config.baseConfig.graph), { graph: config.moduleConfig[module.id], main_act: module.id, exercises_ontology: data_utils_1.getActivitiesInModule(module, data), exercisesMetaData: data.exercises, initialTest: config.initialTest[module.id] }) })),
                        };
                    }
                    catch (err) {
                        if (errorHandler)
                            errorHandler(err, module.id);
                    }
                });
                return [2 /*return*/, banditManchot];
        }
    });
}); };
exports.initBanditManchot = initBanditManchot;
/**
 * Loads the module history for all modules for which the history was not
 * loaded yet. Returns the instances with the historyLoaded parameter set to
 * true if there was no error.
 * The error handlers allows to handle eror when loading one particular
 * module's history.
 */
var loadAllModulesHistory = function (banditManchot, history, errorHandler) {
    return Object.keys(banditManchot).reduce(function (loadedBM, moduleId) {
        var _a;
        if (banditManchot[moduleId].historyLoaded) {
            loadedBM[moduleId] = banditManchot[moduleId];
        }
        else {
            try {
                exports.loadHistoryAndGetNextHierarchyIds(banditManchot[moduleId].instance, (_a = history[moduleId]) !== null && _a !== void 0 ? _a : []);
                loadedBM[moduleId] = __assign(__assign({}, banditManchot[moduleId]), { historyLoaded: true });
            }
            catch (err) {
                if (errorHandler)
                    errorHandler(err, moduleId);
                loadedBM[moduleId] = banditManchot[moduleId];
            }
        }
        return loadedBM;
    }, {});
};
exports.loadAllModulesHistory = loadAllModulesHistory;
var loadHistoryAndGetNextHierarchyIds = function (instance, history) {
    return instance.sample_from_history(history);
};
exports.loadHistoryAndGetNextHierarchyIds = loadHistoryAndGetNextHierarchyIds;
var updateHistoryAndGetNextHierarchyIds = function (instance, historyItem) {
    return instance.sample_from_history([historyItem]);
};
exports.updateHistoryAndGetNextHierarchyIds = updateHistoryAndGetNextHierarchyIds;
var getNextHierarchyId = function (instance) {
    return instance.sample_from_history([]);
};
exports.getNextHierarchyId = getNextHierarchyId;
/**
 * Returns a student's basic diagnostic, which corresponds to the percentage of
 * open objectives in the module and the average score over the last exercices
 * (also expressed as a percentage)
 */
var getStudentBasicDiagnostic = function (instance) {
    var diagnostic = instance.get_student_diagnostic();
    return {
        progression: Math.floor(diagnostic.graphe_coverage_rate * 100),
        averageScore: Math.floor(diagnostic.mean_student_score * 100),
    };
};
exports.getStudentBasicDiagnostic = getStudentBasicDiagnostic;
/**
 * Returns the student's basic diagnosis as provided by the bandit manchot
 */
var getStudentDiagnosis = function (instance) {
    return instance.get_student_diagnostic();
};
exports.getStudentDiagnosis = getStudentDiagnosis;
/**
 * Returns the student's full diagnosis as provided by the bandit manchot
 */
var getStudentFullDiagnosis = function (instance) {
    return instance.get_full_diagnostic();
};
exports.getStudentFullDiagnosis = getStudentFullDiagnosis;
